// Dependencies
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
// Components, actions, assets, etc..
import SignIn from '../../components/auth0/SignIn';
import logo from '../../images/logos/obok-logo-white.svg';
import './Landing.css';

function Landing() {
  const { t } = useTranslation();

  const [verificationMessage, setVerificationMessage] = useState('');
  const [errorVerification, setErrorVerification] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const success = params.get('success');
    const message = params.get('message');

    if (message) {
      setVerificationMessage(decodeURIComponent(message));
      setErrorVerification(success === 'false');
    }
  }, [location?.search]);

  return (
    <div
      className="container-fluid"
      style={{
        background: '#0c0c14',
        minHeight: '100vh',
      }}
    >
      <div className="row align-items-center justify-content-center">
        <div className="d-flex flex-column align-items-center justify-content-center col-12 col-md-5 col-lg-6 col-xl-4 px-lg-6 my-5">
          <div className="p-5">
            <svg width="270px" height="60px">
              <image href={logo} className="img-fluid" alt="Obok logo" width="100%" />
            </svg>
          </div>
          <div>
            {
              verificationMessage && (
                <div className={`alert text-center  ${errorVerification ? 'alert-danger' : 'alert-success text-dark'}`} role="alert">
                  { verificationMessage }
                </div>
              )
            }
          </div>
          <p data-testid="visible" className="text-white text-center mb-3">
            { t('views.dashboard.landing.welcomeBack') }
          </p>
          <div className="row align-items-center justify-content-center mb-5">
            <SignIn />
          </div>
          <p className="text-white text-center mb-3">
            <span>{t('views.dashboard.landing.dontHave')}</span>
            <Link to="/onboarding/ai-powered-cloud-management" className="btn text-primary text-decoration-underline">
              Sign up
            </Link>
          </p>
        </div>
        <div className="col-12 col-md-7 col-lg-6 col-xl-8 d-none d-lg-block">
          <div id="bg-landing" className="vh-100 mr-n3" />
        </div>
      </div>
    </div>
  );
}

export default Landing;
